import { useMemo } from "react";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";
import ChipStatus from "../ChipStatus";

const useScheduleStatusOptions = () => {
  const { t } = useTranslation();

  return [
    { id: 0, name: t({ defaultMessage: "开启" }) },
    { id: 1, name: t({ defaultMessage: "关闭" }) }
  ];
};

const ScheduleStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();
  const options = useScheduleStatusOptions();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={options}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export const ScheduleChipStatus = ({ status }) => {
  const options = useScheduleStatusOptions();
  const option = useMemo(() => {
    return options.find(option => option.id === status);
  }, [status]);

  return (
    <ChipStatus
      type={status === 0 ? "success" : "default"}
      label={option?.name}
    />
  );
};

export default ScheduleStatus;
